/**
 * Background Gradient - スクロール連動ふわふわアニメーション
 * スクロールに合わせて滑らかに動く背景グラデーション
 */

(function() {
  'use strict';

  // ========================================
  // アニメーション有効/無効フラグ（開発用）
  // false にするとアニメーションが停止します
  // ========================================
  const ANIMATION_ENABLED = false;

  // 設定
  const CONFIG = {
    // スムージング係数（0.01〜0.1、小さいほどゆっくり追従）
    smoothing: 0.008,
    // 各グラデーションの動きの設定
    gradients: {
      'cyan': { speedX: 0.15, speedY: 0.08, floatAmplitude: 25, floatSpeed: 0.001 },
      'pink': { speedX: -0.12, speedY: 0.1, floatAmplitude: 30, floatSpeed: 0.00075 },
      'orange': { speedX: 0.1, speedY: -0.06, floatAmplitude: 22, floatSpeed: 0.00125 },
      'blue': { speedX: -0.08, speedY: 0.12, floatAmplitude: 28, floatSpeed: 0.0009 }
    }
  };

  // 状態管理
  let currentScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
  let targetScroll = currentScroll;
  let animationFrame = null;
  let startTime = Date.now();

  // グラデーション要素のキャッシュ
  const gradientElements = {};

  /**
   * 初期化
   */
  function init() {
    // アニメーションが無効の場合は何もしない
    if (!ANIMATION_ENABLED) return;

    // グラデーション要素を取得
    const container = document.querySelector('.bg-gradient-container');
    if (!container) return;

    // 各色のグラデーション要素を取得
    ['cyan', 'pink', 'orange', 'blue'].forEach(color => {
      gradientElements[color] = container.querySelectorAll(`[class*="bg-gradient-css--${color}"]`);
    });

    // 初期状態でtransformをリセット（元の位置を維持）
    Object.keys(gradientElements).forEach(color => {
      gradientElements[color].forEach(el => {
        el.style.transform = 'translate3d(0, 0, 0)';
      });
    });

    // スクロールイベント
    window.addEventListener('scroll', onScroll, { passive: true });

    // 少し遅延してアニメーション開始（レイアウト確定後）
    requestAnimationFrame(() => {
      startTime = Date.now();
      animate();
    });
  }

  /**
   * スクロールイベントハンドラ
   */
  function onScroll() {
    targetScroll = window.pageYOffset || document.documentElement.scrollTop;
  }

  /**
   * 線形補間（lerp）
   */
  function lerp(start, end, factor) {
    return start + (end - start) * factor;
  }

  /**
   * アニメーションループ
   */
  function animate() {
    const elapsed = Date.now() - startTime;

    // スクロール位置をスムーズに追従
    currentScroll = lerp(currentScroll, targetScroll, CONFIG.smoothing);

    // 各グラデーションを更新
    Object.keys(gradientElements).forEach(color => {
      const settings = CONFIG.gradients[color];
      const elements = gradientElements[color];

      elements.forEach((el, index) => {
        // スクロールに基づく移動（上限を設けて制限）
        const maxScroll = 300; // 最大移動量（px）
        const scrollX = Math.max(-maxScroll, Math.min(maxScroll, currentScroll * settings.speedX * 0.3));
        const scrollY = Math.max(-maxScroll, Math.min(maxScroll, currentScroll * settings.speedY * 0.3));

        // ふわふわ浮遊アニメーション（各要素で位相をずらす）- 縦方向メイン
        const phase = index * 1.5;
        const floatX = Math.sin(elapsed * settings.floatSpeed * 0.8 + phase) * settings.floatAmplitude * 0.3;
        const floatY = Math.cos(elapsed * settings.floatSpeed + phase) * settings.floatAmplitude;

        // 緩やかな回転
        const rotation = Math.sin(elapsed * settings.floatSpeed * 0.5 + phase) * 5;

        // ふわふわしたスケール変化（X軸とY軸を別々に、大きめの変化）
        const scaleX = 1 + Math.sin(elapsed * settings.floatSpeed * 0.6 + phase) * 0.25;
        const scaleY = 1 + Math.cos(elapsed * settings.floatSpeed * 0.5 + phase * 1.3) * 0.25;

        // 傾き変形（skew）- より大きな変形
        const skewX = Math.sin(elapsed * settings.floatSpeed * 0.7 + phase * 0.8) * 8;
        const skewY = Math.cos(elapsed * settings.floatSpeed * 0.6 + phase * 1.1) * 6;

        // transform適用（縦方向のみ）
        el.style.transform = `translateY(${floatY}px)`;
      });
    });

    animationFrame = requestAnimationFrame(animate);
  }

  /**
   * クリーンアップ
   */
  function destroy() {
    window.removeEventListener('scroll', onScroll);
    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
    }
  }

  /**
   * グラデーションコンテナの高さをメインコンテンツに合わせて制限し、
   * フッター下にスクロール領域が伸びるのを防止する
   */
  function constrainContainer() {
    var container = document.querySelector('.bg-gradient-container');
    if (!container) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var mainBottom = main.getBoundingClientRect().bottom + (window.pageYOffset || document.documentElement.scrollTop);
    container.style.height = mainBottom + 'px';
    container.style.overflowY = 'clip';
  }

  function initAll() {
    constrainContainer();
    init();
    window.addEventListener('resize', constrainContainer, { passive: true });
  }

  // DOMContentLoaded時に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // ページ離脱時にクリーンアップ
  window.addEventListener('beforeunload', destroy);

})();
